/* eslint-disable @typescript-eslint/no-explicit-any */

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box } from '@mantine/core';

// Components
import { MintStatus } from '@components/atoms/MintStatus';

// Helpers
import {
	capitalizeString,
	getMintStatusLabel,
	getMintStatusType,
} from '@utils/functions';

// Styles
import styles from './CellMintStatus.module.css';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const CellMintStatus = (props: { row: any }) => {
	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={styles.cell}>
			<MintStatus
				type={getMintStatusType(
					props.row && props.row.mintStatus
				)}
			>
				{capitalizeString(
					getMintStatusLabel(
						props.row &&
							props.row.mintStatus.toUpperCase()
					)
				)}
			</MintStatus>
		</Box>
	);
};
